module.exports = __webpack_public_path__ + "static/media/4.22.1112ca26.png";